<app-dialog
  [headerLabel]="headerLabel"
  [primaryActionText]="'ACTION.COPY' | translate"
  [secondaryActionText]="'ACTION.CANCEL' | translate"
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="copyAction"
  [secondaryActionTapped]="cancelAction"
  (onPrimaryAction)="onCopy()"
  (onDialogClose)="onCloseDialog()"
>
  <div id="copy-document-dialog">
    <app-form-master *ngIf="form" [form]="form">
      <app-select-field
        *ngIf="copyAsOptions"
        class="form-row"
        [label]="'LABEL.COPY_AS' | translate"
        fieldId="copy_as_field"
        [formControl]="form.get(formKeys.COPY_AS)"
        [values]="copyAsOptions"
      >
      </app-select-field>

      <app-checkbox-field
        class="form-row"
        [label]="'LABEL.COPY_CLIENT' | translate"
        fieldId="copy_client_field"
        [fieldControl]="form.get(formKeys.COPY_CLIENT)"
        [trackingObject]="trackingObject"
        trackingIdentifier="copy_clients"
        [trackingScreenName]="trackingScreenName"
      >
      </app-checkbox-field>

      <app-checkbox-field
        class="form-row"
        [label]="'LABEL.COPY_ITEMS' | translate"
        fieldId="copy_items_field"
        [fieldControl]="form.get(formKeys.COPY_ITEMS)"
        [trackingObject]="trackingObject"
        trackingIdentifier="copy_items"
        [trackingScreenName]="trackingScreenName"
      >
      </app-checkbox-field>

      <app-checkbox-field
        class="form-row"
        [label]="'LABEL.COPY_ATTACHMENTS' | translate"
        fieldId="copy_attachments_field"
        [fieldControl]="form.get(formKeys.COPY_ATTACHMENTS)"
        [trackingObject]="trackingObject"
        trackingIdentifier="copy_attachments"
        [trackingScreenName]="trackingScreenName"
      >
      </app-checkbox-field>

      <app-checkbox-field
        *ngIf="showCopyTaxesOption"
        class="form-row"
        [label]="'LABEL.COPY_TAXES' | translate"
        fieldId="copy_taxes_field"
        [description]="'LABEL.COPY_TAXES_DESCRIPTION' | translate"
        [fieldControl]="form.get(formKeys.COPY_TAXES)"
        [trackingObject]="trackingObject"
        trackingIdentifier="copy_taxes"
        [trackingScreenName]="trackingScreenName"
      >
      </app-checkbox-field>
    </app-form-master>
  </div>
</app-dialog>
